import Swal from 'sweetalert2';
import triggerChatFlow from '~src/utils/triggerChatFlow';

export const requestNewProject = async () => {
  const result = await Swal.fire({
    icon: 'info',
    title: 'Hai bisogno di un progetto personalizzato?',
    text:
      'Possiamo creare per te dei progetti personalizzati che attualmente non sono presenti. Clicca su "Richiedi Progetto" per indicarci quale progetto vorresti creare. Invia il messaggio al nostro team una volta completato il testo',
    showCancelButton: true,
    confirmButtonText: '<span>Richiedi Progetto</span>',
    cancelButtonText: 'Non adesso',
    customClass: {
      confirmButton: 'requestNewProject',

      confirmButtonColor: '#278e8e',
    },
  });

  if (result.isConfirmed) {
    triggerChatFlow(
      'Salve, vorrei richiedere la creazione di un nuovo tipo di progetto. Dettagli: '
    );
  }
};

export const requestNewFormat = async () => {
  const result = await Swal.fire({
    icon: 'info',
    title: 'Hai bisogno di un formato personalizzato?',
    text:
      'Se non hai trovato il tuo formato clicca su "Richiedi Formato" per indicarci quale formato vorresti creare. Invia il messaggio al nostro team una volta completato il testo',
    showCancelButton: true,
    confirmButtonText: '<span>Richiedi Formato</span>',
    cancelButtonText: 'Non adesso',
    customClass: {
      confirmButton: 'requestNewFormat',

      confirmButtonColor: '#278e8e',
    },
  });

  if (result.isConfirmed) {
    triggerChatFlow('Salve, avrei bisogno di un nuovo formato. Specifiche: ');
  }
};

export const requestNewInfoAf = async () => {
  const result = await Swal.fire({
    icon: 'info',
    title: 'Vuoi maggiori informazioni su AnnunciFunebri.it?',
    text:
      'Indicaci come e quando possiamo raggiungerti e invia il messaggio al nostro team una volta completato il testo',
    showCancelButton: true,
    confirmButtonText: '<span>Richiedi Informazioni</span>',
    cancelButtonText: 'Non ora',
    customClass: {
      confirmButton: 'requestNewInfoAf',

      confirmButtonColor: '#278e8e',
    },
  });

  if (result.isConfirmed) {
    triggerChatFlow(
      'Salve, vorrei maggiori informazioni su AnnunciFunebri.it. Potete contattarmi? Recapito e disponibilità: '
    );
  }
};

export const requestNewEvent = async () => {
  const result = await Swal.fire({
    icon: 'info',
    title: 'Hai bisogno di un Evento Personalizzato?',
    text:
      'Se desideri aggiungere un evento personalizzato per questo progetto clicca su "Richiedi Evento" per indicarci quale evento vorresti creare. Invia il messaggio al nostro team una volta completato il testo',
    showCancelButton: true,
    confirmButtonText: '<span>Richiedi Evento</span>',
    cancelButtonText: 'Non adesso',
    customClass: {
      confirmButton: 'requestNewEvent',

      confirmButtonColor: '#278e8e',
    },
  });

  if (result.isConfirmed) {
    triggerChatFlow(
      'Salve, vorrei aggiungere un evento personalizzato per questo progetto. Dettagli: '
    );
  }
};
export const requestNewTemplate = async () => {
  const result = await Swal.fire({
    icon: 'info',
    title: 'Hai bisogno di un modello personalizzato?',
    text:
      'Se desideri un modello personalizzato per questo progetto clicca su "Richiedi Modello". Invia il messaggio al nostro team una volta completato il testo',
    showCancelButton: true,
    confirmButtonText: '<span>Richiedi Modello</span>',
    cancelButtonText: 'Non adesso',
    customClass: {
      confirmButton: 'requestNewTemplate',

      confirmButtonColor: '#278e8e',
    },
  });

  if (result.isConfirmed) {
    triggerChatFlow(
      'Salve, vorrei un modello personalizzato per questo progetto. Dettagli: '
    );
  }
};
